import { Component, inject, Input } from '@angular/core';

import { FeatureCarouselComponent } from '@usheru-hff/community-elements/utils';
import { NewsService } from '@usheru-hff/sdk/news';
import { News } from '@usheru-hff/shared/domain';

@Component({
  selector: 'community-feature-news-carousel',
  templateUrl: './feature-news-carousel.component.html',
  styleUrls: ['./feature-news-carousel.component.scss']
})
/**
 * @description This component is used to display a carousel of movies, it will be in charge of
 * interpreting dashboard community movie slider parameters and displaying the movies in a carousel
 * applying given parameters
 */
export class FeatureNewsCarouselComponent extends FeatureCarouselComponent<News> {
  newsService = inject(NewsService);

  @Input() set news(news: News[]) {
    this.items = news;
  }
  @Input() viewAllLink = '/news';
  @Input() newsSubtitle =
    $localize`:@@public.commons.news.subtitle:Lore ipsum dolor sit amet, consectetur adipiscing elit.`;

  news$ = this.newsService.getNews(1, 10);
  title = $localize`:@@title.news:News`;
}
